import React from 'react';
import { Construction } from 'lucide-react';

interface PlaceholderProps {
  children: React.ReactNode;
  showIndicator?: boolean;
}

export function Placeholder({ children, showIndicator = true }: PlaceholderProps) {
  return (
    <div className="relative">
      {showIndicator && (
        <div className="absolute -top-2 -right-2 bg-amber-100 text-amber-800 px-2 py-1 rounded-md text-xs font-medium flex items-center gap-1 shadow-sm">
          <Construction className="w-3 h-3" />
          Placeholder
        </div>
      )}
      <div className="border border-gray-200 bg-amber-50/50 rounded-lg">
        {children}
      </div>
    </div>
  );
}

export function PlaceholderText({ text }: { text: string }) {
  return (
    <span className="inline-flex items-center px-2 py-1 rounded bg-amber-100 text-amber-800 text-sm">
      <Construction className="w-3 h-3 mr-1" />
      {text}
    </span>
  );
}